import { useHistory, useLocation } from 'react-router-dom';

/** Захиалгын хаяг оруулах хэлбэр */
export const ADDRESS_TAB = {
  MAP: 'addressMap',
  DETAIL: 'addressDetail',
};

export const DEFAULT_ADDRESS_TAB = ADDRESS_TAB.MAP;

const SEPARATOR = ',';

/**
 * Захиалга тус бүрийн хаягийн табыг URL-ийн `?tab=` параметр агуулна.
 *
 * Энэ алхам дээр 12 хүртэл захиалга зэрэг харагддаг тул `tab` нь захиалгын
 * дугаараар эрэмбэлэгдсэн жагсаалт: `?step=1&tab=addressMap,addressDetail` —
 * 1-р захиалга газрын зургаар, 2-рх гараас бичихээр. Хойд талын анхдагч
 * утгуудыг хасаж URL-ыг цэвэр байлгана (`?tab=addressDetail`).
 *
 * Ингэснээр refresh хийхэд, алхам хооронд явахад сонгосон таб хэвээрээ байна.
 * Аппын бусад дэлгэц (clients, profile, product гэх мэт) ижил `?tab=`
 * параметрийн хэлбэрийг хэрэглэдэг.
 */
const useOrderTabs = () => {
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const tabs = (params.get('tab') ?? '')
    .split(SEPARATOR)
    .map((tab) => tab.trim())
    .filter(Boolean);

  const write = (list) => {
    const trimmed = [...list];
    // Хойд талын анхдагч утгууд URL-д хэрэггүй
    while (trimmed.length && trimmed[trimmed.length - 1] === DEFAULT_ADDRESS_TAB) trimmed.pop();

    const nextParams = new URLSearchParams(location.search);
    if (trimmed.length) nextParams.set('tab', trimmed.join(SEPARATOR));
    else nextParams.delete('tab');

    // URLSearchParams нь таслалыг `%2C` болгодог — URL уншихад ойлгомжтой байхаар
    // эргүүлж тавина (таслал нь query-д зөвшөөрөгдсөн тэмдэгт).
    const search = nextParams.toString().replace(/%2C/g, SEPARATOR);

    /**
     * Таб солих нь алхам биш тул history-д шинэ бичлэг үүсгэхгүй — browser-ийн
     * back дарахад таб бүрийг нэг нэгээр нь буцахгүй, өмнөх алхам руу шилжинэ.
     */
    history.replace({ pathname: location.pathname, search });
  };

  /** Тухайн захиалгын таб (URL-д байхгүй бол анхдагч) */
  const getTab = (index) => tabs[index] ?? DEFAULT_ADDRESS_TAB;

  /** Захиалгын табыг URL-д бичих — дундах захиалгуудыг анхдагчаар нөхнө */
  const setTab = (index, tab) => {
    const list = [...tabs];
    while (list.length < index) list.push(DEFAULT_ADDRESS_TAB);
    list[index] = tab;
    write(list);
  };

  /** Захиалга устгахад түүний табыг хасаж, дараагийнхыг нь ахиулна */
  const removeTab = (index) => {
    const list = [...tabs];
    if (index < list.length) list.splice(index, 1);
    write(list);
  };

  return { getTab, setTab, removeTab };
};

export default useOrderTabs;
